<div class="role-permissions-settings" data-automation-id="role-permissions-settings-container">
    <div class="header-bar" data-automation-id="role-permissions-settings-header">
        <button type="button" data-automation-id="role-permissions-settings-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="!isDirty || isBusy" *ngIf="hasPermissions">Save</button>
        <button type="button" data-automation-id="role-permissions-settings-discard-changes-button"
            class="secondary-button" (click)="discardChanges()" [disabled]="isBusy || !isDirty"
            *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="role-permissions-settings-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <form class="eDiscovery-content" #eDiscoveryForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="left-section">
            <div class="panel-grid">
                <res-generic-grid #panelGrid [gridName]="panelGridName" [pagerVisible]="false"
                    [automationId]="panelAutomationId" [columnDefs]="panelGridColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
            <div class="navigation-tree-node-grid">
                <res-generic-grid #navigationTreeNodeGrid [gridName]="navigationTreeNodeGridName" [pagerVisible]="false"
                    [automationId]="navigationTreeNodeAutomationId" [columnDefs]="navigationTreeColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
            <div class="document-actions">
                <div class="section-heading">
                    Document Actions
                </div>
                <div class="modal-row">
                    <ul class="list-unstyled">
                        <li>
                            <res-custom-checkbox name="addRemoveTagsCheckbox" automationId="add-remove-tags-checkbox"
                                [(ngModel)]="addRemoveTagsCheckbox" content="Add / Remove Tag(s)"
                                (ngModelChange)="toggleCheckbox('DOCUMENT_TAGS')"
                                [cellClickedCallback]="cellClickedCallback" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="addRemoveFolderCheckbox"
                                automationId="add-remove-folder-checkbox" [(ngModel)]="addRemoveFolderCheckbox"
                                content="Add to / Remove from a Folder"
                                (ngModelChange)="toggleCheckbox('DOCUMENT_FOLDER')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="addRemoveCustodianCheckbox"
                                automationId="add-remove-custodian-checkbox" [(ngModel)]="addRemoveCustodianCheckbox"
                                content="Add to / Remove from a Custodian / Batch / MediaID"
                                (ngModelChange)="toggleCheckbox('DOCUMENT_CUSTODIAN')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="downloadNativeCheckbox" automationId="download-native-checkbox"
                                [(ngModel)]="downloadNativeCheckbox" content="Download Native"
                                (ngModelChange)="toggleCheckbox('DOWNLOAD_NATIVES')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="downloadPDFCheckbox" automationId="download-pdf-checkbox"
                                [(ngModel)]="downloadPDFCheckbox" content="Download PDF"
                                (ngModelChange)="toggleCheckbox('DOWNLOAD_PDF')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="other">
                <div class="section-heading">
                    Other
                </div>
                <div class="modal-row">
                    <ul class="list-unstyled">
                        <li>
                            <res-custom-checkbox name="connectorAccessCheckbox" automationId="connector-access-checkbox"
                                [(ngModel)]="connectorAccessCheckbox" content="Connector Access"
                                (ngModelChange)="toggleCheckbox('CONNECTOR_ACCESS')" [disabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="projectMonitoringAccessCheckbox"
                                automationId="project-monitoring-access-checkbox"
                                [(ngModel)]="projectMonitoringAccessCheckbox" content="Project Monitoring Access"
                                (ngModelChange)="toggleCheckbox('PROJECT_MONITORING_ACCESS')"
                                [disabled]='isFieldDisabled()'></res-custom-checkbox>
                            <res-custom-checkbox name="auditAccessCheckbox" automationId="audit-access-checkbox"
                                [(ngModel)]="auditAccessCheckbox" content="Audit Access"
                                (ngModelChange)="toggleCheckbox('AUDIT_LOG')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="documentReportsCheckbox" automationId="document-reports-checkbox"
                                [(ngModel)]="documentReportsCheckbox" content="Document Reports"
                                (ngModelChange)="toggleCheckbox('DOCUMENT_REPORTS')" [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="workflowLockUnlockCheckbox"
                                automationId="workflow-lock-unlock-checkbox" [(ngModel)]="workflowLockUnlockCheckbox"
                                content="Workflow Lock/Unlock" (ngModelChange)="toggleCheckbox('LOCK_UNLOCK_WORKFLOW')"
                                [isDisabled]='isFieldDisabled()'></res-custom-checkbox>
                            <res-custom-checkbox name="drAccessCheckbox" automationId="dr-access-checkbox"
                                [(ngModel)]="drAccessCheckbox" content="DR Access"
                                (ngModelChange)="toggleCheckbox('TLS_DR_ACCESS')"
                                [disabled]='isFieldDisabled()'></res-custom-checkbox>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tls-object" [hidden]="!isTLSExpress">
                <res-generic-grid #tlsObjectGrid [gridName]="tlsObjectGridName" [pagerVisible]="false"
                    [automationId]="tlsObjectAutomationId" [columnDefs]="tlsObjectGridColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
            <div class="tls-other" [hidden]="!isTLSExpress">
                <div class="section-heading">
                    Reef Express Other
                </div>
                <div class="modal-row">
                    <ul class="list-unstyled">
                        <li>
                            <res-custom-checkbox name="openInRelativityCheckbox"
                                automationId="open-in-relativity-checkbox" [(ngModel)]="openInRelativityCheckbox"
                                [content]="openInTitle" (ngModelChange)="toggleCheckbox('TLS_OPEN_IN_RELATIVITY')"
                                [disabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="billingOverviewCheckbox" automationId="billing-overview-checkbox"
                                [(ngModel)]="billingOverviewCheckbox" content="Billing Overview"
                                (ngModelChange)="toggleCheckbox('TLS_BILLING_OVERVIEW_TAB')"
                                [disabled]='isFieldDisabled()'></res-custom-checkbox>
                            <res-custom-checkbox name="viewOthersDataSetsCheckbox"
                                automationId="view-others-data-sets-checkbox" [(ngModel)]="viewOthersDataSetsCheckbox"
                                content="View Others' Data Sets"
                                (ngModelChange)="toggleCheckbox('TLS_VIEW_OTHERS_DATA_SETS')"
                                [isDisabled]='isFieldDisabled()'>
                            </res-custom-checkbox>
                            <res-custom-checkbox name="exportToRelativityCheckbox"
                                automationId="export-to-relativity-checkbox" [(ngModel)]="exportToRelativityCheckbox"
                                [content]="exportToTitle" (ngModelChange)="toggleCheckbox('TLS_EXPORT_TO_VIEW')"
                                [isDisabled]="isFieldDisabled()"></res-custom-checkbox>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="vertical-spacer"></div>

        <div class="right-section">
            <div class="setting-grid">

                <res-generic-grid #settingGrid [gridName]="settingGridName" [pagerVisible]="false"
                    [automationId]="settingAutomationId" [columnDefs]="settingGridColDefs"
                    [cellClickedCallback]="cellClickedCallback">
                </res-generic-grid>
            </div>
        </div>
    </form>

</div>